
import NavMenu from '../section/LoggedInNav.js';
import SITELINKS from '../section/Footer.js';
import Banner from '../section/Title.js';
import resetPassword from '../images/resetPassword.png';
import filterPayments from '../images/filterPayments.png';
import exportPayments from '../images/exportPayments.png';
import registerAccount from '../images/registerAccount.png';



//boostrap components 
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export const FaqPage = () => {
  
    return (
      <div className='App'>

        <div className='hidden'>
          <Banner/>
        </div>        
        <NavMenu/> 
        <Banner/>
        
        <Container className='App'>
          <Row>
            <Col xs={12} md={12} lg={12} xl={12}>
              <div className='App empBorder padding text-center'>
                <h1 className='text-center emphTitle'>FAQ Page</h1>
                <p className=' '>
                  <i>Page Updated 01/01/2026</i>
                </p>
                <br></br><hr></hr>
                <h4 className='emphTitle text-center'> How do I create an account?</h4>
                <p className='  '>Please Navigate to the Portal Dashboard and select Create Account / Register Account. 
                  You can also visit the webpage here:   
                  <a className='btn btn-primary' href='/register'>Register</a>
                </p>
              
               <img src={registerAccount} className='mLogo' alt="mhb-site-logo.png" />

                <ol className='text-center padding'>
                  <li><p>Enter your Metro Housing Boston Affiliated Email Address. If you do not know this, please check our FAQ pag for more information</p></li>
                  <li><p>Please confirm your account by entering the PIN that is sent to your MHB affiliated email that was used in the first step</p></li>
                  <li><p>Once Logged in, please click on the Payments link to navigate and view all MHB Payments for your properties</p></li>
                </ol>
                
                <br></br>
                <hr></hr>

                <h4 className='emphTitle text-center'>Unable to View Payments?</h4>
                <p className='  '>Please make sure that you are signed up & logged in using your Metro Housing Boston Affiliated email account. 
                  This is the account you provided to Metro Housing Boston when the application for Rent Relief was filed</p>
                <p className='  '>Please file a request with <a className='btn btn-primary' href="mailto:portalhelp@mbhp.org?subject=[Update Portal Email]">Portal Help / Technical Support</a>to update your MHB affiliated email account</p>
                <br></br>
                <hr></hr>

                <h4 className='emphTitle text-center'>Incorrect data submitted when account was created?</h4>
                <p className='  '>Please file a request with <a className='btn btn-primary'href="mailto:portalhelp@mbhp.org?subject=[Incorrect Account Data]">Portal Help / Technical Support</a> to edit your account</p>
                <br></br>
                <hr></hr>

                <h4 className='emphTitle text-center'>Duplicate Payment Data shown on Payments Page?</h4>
                <p className='  '>Please file a request with <a className='btn btn-primary' href="mailto:portalhelp@mbhp.org?subject=[Duplicate Payment Data]">Portal Help / Technical Support</a> to edit the invalid payment information</p>
                <br></br>
                <hr></hr>

                <h4 className='emphTitle text-center'> update my direct deposit information</h4>
                <p className='  '>Please contact OwnerServices@metrohousingboston.org <a className='btn btn-primary' href="mailto:OwnerServices@metrohousingboston.org?subject=[Duplicate Payment Data]">Owner Services</a></p>
                <br></br>
                <hr></hr>

                <h4 className='emphTitle text-center'> update my rent-share</h4>
                <p className='  '>Please contact OwnerServices@metrohousingboston.org  <a className='btn btn-primary' href="mailto:OwnerServices@metrohousingboston.org?subject=[Duplicate Payment Data]">Owner Services</a></p>
                <br></br>
                <hr></hr>


                <h4 className='emphTitle text-center'> Filter and sort my payments?</h4>
                <p className='  '>Please navigate to the Payments page. On the right-hand side of the payments database table, select the Date Range tab and choose the timeframe you wish to review. You may select from predefined options such as the last 7 days or 30 days, or specify a custom range if you need to generate a report covering multiple years of remittance activity.</p>
                <img src={filterPayments} className='mLogo' alt="mhb-site-logo.png" />
                <br></br>
                <hr></hr>

                <h4 className='emphTitle text-center'> Export payments?</h4>
                <p className='  '>Please navigate to the Payments page. Begin by selecting the desired payment range using the filter section outlined above. Once the relevant payments are displayed, click the Export button and choose the appropriate option—S8, MRVP, HAPPY, or WSD payments. You may also choose to export all database tables into a single XLSX file.</p>
                <img src={exportPayments} className='mLogo' alt="mhb-site-logo.png" />
                <br></br>
                <hr></hr>

                <h4 className='emphTitle text-center'> Reset my password?</h4>
                <p className='  '>Please reset your password by clicking on the Forgot Your Password Link Illustrated below. You can find this on the Home, Registration, or Login Page.  </p>
                <p>Login Page URL: <a href="https://mhbportal.org/login">https://mhbportal.org/login</a></p>
                <img src={resetPassword} className='mLogo' alt="mhb-site-logo.png" />
                <br></br>
                <hr></hr>

                <h4 className='emphTitle text-center'> Submit Feedback on the Portal</h4>
                <p className='  '>Click here to get started: <a className='btn btn-primary' href="https://forms.office.com/Pages/ResponsePage.aspx?id=J8xXIgxdK0y6AnOQOwjqAHVPPCEmmcRLu9IABP8zZRBUQlFDU0RFQUxRRjdCTzY4NTZQWjVMS09SVC4u">MHB Portal Feedback Form</a> </p>
                <br></br>
                <hr></hr>
              </div>
            </Col>
            <Col xs={12} md={12} lg={12} xl={12}>
                
            </Col>
          </Row>
        </Container>  
        <SITELINKS/> 
      </div>
    );
  };